import { useContext } from 'react';
import { AppSettingsContext, IAppSettingsContext } from 'context';

export function useAppSettings(): IAppSettingsContext {
  return useContext(AppSettingsContext)!;
}
